var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestLoopCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.414062 2.65517L2.06923 4.31034L5.37958 1",
    stroke: "#0550DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03516 8.03125L11.1731 12.1692",
    stroke: "#0550DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.27344H5.37931",
    stroke: "#0550DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7578H5.37931",
    stroke: "#0550DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62109 4.3125H12.0004",
    stroke: "#0550DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1731 8.03125L7.03516 12.1692",
    stroke: "#0550DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62109 1.82812H12.0004",
    stroke: "#0550DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestLoopCard);
export default __webpack_public_path__ + "static/media/TestLoopCard.bec729bff5243f8d09b72b21a5acfd8c.svg";
export { ForwardRef as ReactComponent };